import Countdown from './Countdown';
import { formatCeremonyDate } from '../util/formatCeremonyDate';
import useLocale from '../util/useLocale';

let CountdownWithDate = ({
  timestampSeconds,
}: {
  timestampSeconds: number;
}) => {
  let locale = useLocale();
  let isPast = timestampSeconds * 1000 <= Date.now();
  return (
    <div className="flex mr-8">
      {!isPast && (
        <div className="mr-16">
          {formatCeremonyDate(timestampSeconds, locale)}
        </div>
      )}
      <div className={isPast ? '' : 'text-neutral-600'}>
        <Countdown toTimestamp={timestampSeconds * 1000} />
      </div>
    </div>
  );
};

export default CountdownWithDate;
